function createElement(tag, attrs, children) {
  var el = document.createElement(tag)
  attrs = attrs || {}
  Object.keys(attrs).forEach(function (k) {
    if (k === 'class') el.className = attrs[k]
    else el.setAttribute(k, attrs[k])
  })
  ;(children || []).forEach(function (c) {
    if (c === null || c === undefined) return
    el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c)
  })
  return el
}

function loadCss(cssText) {
  if (document.querySelector('style[data-web-chat]')) return
  var l = document.createElement('style')
  l.setAttribute('data-web-chat', '1')
  l.appendChild(document.createTextNode(cssText))
  document.head.appendChild(l)
}

export { createElement, loadCss }
